import { Group } from 'three'
import { GLTFLoader, GLTF } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'

//declare const dracoLoader: DRACOLoader;
const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/')
dracoLoader.setDecoderConfig({ type: 'wasm' })

function isUrl(str: string): boolean {
	return str.startsWith('http://') || str.startsWith('https://') || str.startsWith('blob:')
}

function processScene(scene: Group): Group {
	scene.name = 'Neatolabs'

	// Traverse the scene graph to modify all meshes in one go
	scene.traverse((child: any) => {
		if (child.isMesh) {
			if (!Array.isArray(child.material)) {
				child.material = child.material.clone() // Clone material to avoid shared references
				child.material.transparent = true
			}
		}
	})

	return scene
}

export default function loadGLBFromBase64(base64: string): Promise<Group> {
	return new Promise((resolve, reject) => {
		const loader = new GLTFLoader()
		loader.setDRACOLoader(dracoLoader)

		if (isUrl(base64)) {
			// Load from URL directly
			loader.load(
				base64,
				(gltf: GLTF) => resolve(processScene(gltf.scene)),
				undefined,
				(error) => {
					console.error('An error happened while loading the GLB from URL:', error)
					reject(error)
				},
			)
		} else {
			// Load from base64 string
			const base64Data = base64.includes(',') ? base64.split(',')[1] : base64

			// Decode the base64 string into a binary ArrayBuffer
			const binaryString = atob(base64Data)
			const len = binaryString.length
			const arrayBuffer = new ArrayBuffer(len)
			const uintArray = new Uint8Array(arrayBuffer)
			for (let i = 0; i < len; i++) {
				uintArray[i] = binaryString.charCodeAt(i)
			}

			loader.parse(
				arrayBuffer,
				'',

				// Success callback
				(gltf: GLTF) => resolve(processScene(gltf.scene)),

				// Error callback
				(error) => {
					console.error('An error happened while parsing the GLB:', error)
					reject(error)
				},
			)
		}
	})
}